import React from 'react'
import { useHistory } from 'react-router-dom'
import { useApiFormAnalyticType } from '../../../../api-new/state/analytics'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { IconAdd } from '../../../../shared/icon/icon'
import { Card } from '../../../../shared/card/card'
import { Form, FormSubmitCancel, FormText, FormTextArea } from '../../../../shared/form/form'

export const AnalyticTypeAdd = () => {
  const history = useHistory()

  const apiFormAnalyticType = useApiFormAnalyticType()

  const handleSubmit = async data => {
    await apiFormAnalyticType.post(data)
    history.goBack()
  }

  const handleClose = () => history.goBack()

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="Add analytic type">
        <CardFullHeightScrollY title="Add analytic type">
          <Card>
            <Form state={apiFormAnalyticType.form} onSubmit={handleSubmit}>
              <FormText label="name" name="name" autoFocus />
              <FormTextArea label="description" name="description" />
              <FormSubmitCancel onCancel={handleClose} />
            </Form>
          </Card>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
